export class EmailSignature {
  id?: number;
  member?: number;
  content?: string;
}
